import React,{useState} from 'react';
import Breadcrumb from '../components/Breadcrumb';
// import { IoSearchSharp } from 'react-icons/io5';
// import { BiSolidEditAlt } from 'react-icons/bi';
import { IoEye } from 'react-icons/io5';
import { FaDownload } from 'react-icons/fa';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { format as jalaliFormat } from 'date-fns-jalali'

const CreateBook = () => {
  const [open, setOpen] = useState(false);
  const [caseData, setcaseData] = useState({
    date:jalaliFormat(new Date(),'yyyy/MM/dd')
  })
  const [date, setDate] = useState(new Date())
  const handleDate = (date:any) => {
    setDate(new Date(date))
}
  return (
    <>
      <Breadcrumb pageName="کتابساز" />
      <div className="w-full max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <table className="w-full">
          <thead>
            <tr
              className="grid grid-cols-5 rounded-t-sm bg-[#B1B2FF] text-[#030637]"
              style={{ fontFamily: 'Btitr' }}
            >
              <th className="flex h-15 items-center justify-center rounded-tl-sm p-1 text-2xl font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> ردیف </span>
                <span className="block lg:hidden"> ردیف </span>
              </th>
              <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> عنوان کتاب </span>
                <span className="block lg:hidden"> عنوان کتاب </span>
              </th>
              <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> موضوع </span>
                <span className="block lg:hidden"> موضوع </span>
              </th>
              <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> پیش نمایش </span>
                <span className="block lg:hidden"> پیش نمایش </span>
              </th>

              <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> دانلود </span>
                <span className="block lg:hidden"> دانلود </span>
              </th>
              {/* <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> حذف </span>
                <span className="block lg:hidden"> delete </span>
              </th> */}
              {/* <th className="flex h-15 items-center justify-center p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> Friday </span>
                <span className="block lg:hidden"> Fri </span>
              </th>
              <th className="flex h-15 items-center justify-center rounded-tr-sm p-1 text-xs font-semibold sm:text-base xl:p-5">
                <span className="hidden lg:block"> Saturday </span>
                <span className="block lg:hidden"> Sat </span>
              </th> */}
            </tr>
          </thead>
          <tbody>
            {/* <!-- Line 1 --> */}
            <tr className="grid grid-cols-5 text-center">
              <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 sm:flex sm:items-center sm:justify-center sm:h-31 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-4 xl:h-25">
                <span className="font-medium text-black dark:text-white">
                  1
                </span>
              </td>
              <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 sm:flex sm:items-center sm:justify-center sm:h-31 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-6 xl:h-25">
                <span className="font-medium text-black dark:text-white">
                  2
                </span>
              </td>
              <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 sm:flex sm:items-center sm:justify-center sm:h-31 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-6 xl:h-25">
                <span className="font-medium text-black dark:text-white">
                  3
                </span>
              </td>
              {/* <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-6 xl:h-25">
                <span className="font-medium text-black dark:text-white">
                  4
                </span>
              </td> */}
              <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 sm:flex sm:items-center sm:justify-center sm:h-31 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-6 xl:h-25">
                <span className="font-medium text-black dark:text-white">
                  <button>
                    <IoEye size={30} className="text-[#00A9FF] sm:text-xs xl:text-xl" />
                  </button>
                </span>
              </td>
              <td className="ease relative h-10 cursor-pointer border-b-2 border-t-2 sm:flex sm:items-center sm:justify-center sm:h-31 border-stroke p-2 transition duration-500  dark:border-strokedark dark:hover:bg-meta-4 md:h-25 md:p-6 xl:h-25">
                <span className="font-medium text-black dark:text-white flex items-center justify-center">
                  <button>
                    <FaDownload size={25} className="text-[#00A9FF]" />
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        {/* </div>  */}
        <div className="w-full mt-20 border-2 border-[#E5E1DA] rounded-lg p-5">
          <div className="w-full  items-center flex">
            <label
              className="ml-5 text-center flex items-center justify-center w-[10%] text-xl"
              style={{ fontFamily: 'Btitr' }}
            >
              عنوان مجموعه
            </label>
            <input
              type="text"
              className="w-full h-14 text-2xl  border-2 mt-5 outline-none border-body p-5 rounded-xl"
            />
          </div>
          <div className="w-full grid grid-cols-1 gap-5">
            <div className="w-full  items-center flex">
              <div className="flex items-center mt-5 mb-4 justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  قانون
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  مقرره
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  رای
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  نظر
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
            </div>

            <div className="w-full  items-center flex justify-between gap-4">
              <div className='w-full flex '>
              <label
                className="text-right  flex items-center justify-center w-[30%] sm:w-[10%] sm:ml-3 xl:w-[30%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
                از تاریخ
                </label>
                <div className='w-[100%] sm:w-[40%] xl:w-[100%] md:w-[40%]'>
                <DatePicker
                className='custom-calendar'
                inputClass="custom-input"
                calendarPosition="bottom-center"
                  value={date}
                  locale={persian_fa}
                calendar={persian}
                onChange={handleDate}
                />
                </div>
            
              </div>

                <div className='w-full flex '>
              <label
                className=" text-center flex items-center justify-center w-[30%] sm:w-[10%] sm:ml-3 xl:w-[30%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
              تا تاریخ
                </label>
                <div  className='w-[100%] sm:w-[40%] xl:w-[100%] md:w-[40%]'>
                <DatePicker
                className='custom-calendar'
                inputClass="custom-input"
                calendarPosition="bottom-center"
                  value={date}
                  locale={persian_fa}
                calendar={persian}
                onChange={handleDate}
                />
                </div>
              </div>
            
            </div>
            <div className="w-full  items-center flex">
              <label
                className="ml-5 text-center flex items-center justify-center w-[10%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
                موضوع
              </label>
              <select className="w-[90%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                <option>1</option>
                <option>2</option>
                <option>3</option>
              </select>
            </div>
            <div className="w-full items-center justify-center  flex ">
            <label
              className="ml-5  w-[10%] text-xl"
              style={{ fontFamily: 'Btitr' }}
            >
              کلید واژه (ها)
            </label>
            <input
              type="text"
              className="w-full h-15 text-2xl  border-2 mt-5 outline-none border-body p-5 rounded-xl"
            />
            </div>
            
            <div className="w-full  items-center flex">
              <div className="flex items-center mt-5 mb-4 justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  فهرست تاریخی
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  فهرست موضوعی
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  فهرست تنقیحی
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              {/* <div className="flex items-center mt-5 mb-4 mr-5  justify-center w-full">
                <label
                  className="ms-2  font-bold text-gray-900 dark:text-gray-300 text-2xl"
                  style={{ fontFamily: 'Bmitra' }}
                >
                  نظر
                </label>
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-8 h-8 text-blue-600 mr-3 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div> */}
            </div>



          </div>
        
          <div className=" flex gap-5 w-full mt-10 ltr p-5">
            {/* <button
              className="w-40 p-2 rounded-lg text-2xl text-white font-bold
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
              style={{ fontFamily: 'Bmitra' }}
            >
              حذف
            </button> */}
            <button
              className="w-80 p-3 rounded-full text-2xl text-white
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
              style={{ fontFamily: 'Bmitra' }}
            >
              تدوین و تنقیح مجموعه 
            </button>
            {/* <button
              className="w-40 p-2 rounded-lg text-2xl hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
              style={{ fontFamily: 'Bmitra' }}
            >
              ثبت
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBook;
